<template>
    <div class="wrapper clearfix">
        <div class="content-box" >
            <div id="content" ref="currentHeight" :style="{ 'min-height':fullHeight + 'px' }">
                <HeaderA ></HeaderA>
                <router-view></router-view>
                <BottomA></BottomA>
            </div>
        </div>
    </div>
</template>

<script>
import bus from './bus';
export default {
    data() {
        return {
            tagsList: [],
            collapse: false,
            fullHeight: 0,
            bottomShow:true
        };
    },
    mounted(){
    },
    created() {
        let contentHeight = document.documentElement.clientHeight - 70
        this.fullHeight = contentHeight
        // this.$store.commit("contentHeight", { contentHeight : contentHeight });
        //每次路由发生跳转，都将滚动移动至顶部
        this.$router.afterEach((to,from) =>{
            document.getElementById('content').scrollTop = 0
        })
        //更改滚动条高度
        bus.$on('changeScroll',height => {
            document.getElementById('content').scrollTop = height
        })
        // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
        bus.$on('tags', msg => {
            let arr = [];
            for (let i = 0, len = msg.length; i < len; i++) {
                msg[i].name && arr.push(msg[i].name);
            }
            this.tagsList = arr;
        });
    }
};
</script>
